'use client';

import { Button, Card, Grid, Heading, Stack, Text } from '@cortex/ui';
import { Check, Edit } from 'lucide-react';

import { QUESTION_ENTER_ANIMATION } from './styles';
import type { SummaryConfirmationProps } from './types';

export function SummaryConfirmation({
  summary,
  confirmationQuestion = 'Does this capture your request?',
  onConfirm,
  onEdit,
}: SummaryConfirmationProps) {
  return (
    <Stack gap="lg" className={QUESTION_ENTER_ANIMATION}>
      <Stack gap="xs">
        <Heading level={3} className="mb-1 text-lg font-medium">
          Request Summary
        </Heading>
        <Text color="muted" size="sm">
          {confirmationQuestion}
        </Text>
      </Stack>

      <Card className="p-6">
        <Stack gap="md">
          {summary.map((item, index) => (
            <Stack
              key={index}
              gap="xs"
              className="border-border border-b pb-4 last:border-0 last:pb-0"
            >
              <Text color="muted" size="sm" weight="medium">
                {item.label}
              </Text>
              <Text>{item.value}</Text>
            </Stack>
          ))}
        </Stack>
      </Card>

      <Grid columns={1} gap="sm" className="sm:grid-cols-2">
        <Button
          onClick={onConfirm}
          size="lg"
          variant="default"
          className="h-auto flex-col gap-2 py-4"
        >
          <Check className="h-5 w-5" />
          <Text as="span">Yes, looks good</Text>
        </Button>
        <Button
          onClick={onEdit}
          size="lg"
          variant="outline"
          className="h-auto flex-col gap-2 py-4"
        >
          <Edit className="h-5 w-5" />
          <Text as="span">No, let me edit</Text>
        </Button>
      </Grid>
    </Stack>
  );
}
